import type { AlpineComponent } from 'alpinejs'

type HomepageHeaderComponent = {
  prevScrollpos: number
}

export const homepageHeader = (): AlpineComponent<HomepageHeaderComponent> => ({
  prevScrollpos: window.pageYOffset,

  init() {
    const root = this.$root
    const headerBottom = root.offsetTop + root.offsetHeight

    window.addEventListener('scroll', () => {
      const currentScrollPos = window.pageYOffset
      const shouldHide = this.prevScrollpos <= currentScrollPos && currentScrollPos > headerBottom
      root.classList.toggle('is-hidden', shouldHide)
      this.prevScrollpos = currentScrollPos
    })
  },
})

type PasswordResetComponent = {
  password: string
  passwordConfirmation: string
  passwordTooShort: boolean
  infoColorClass: 'text-gray-500' | 'text-red-600' | 'text-green-600'
  validConfirmation: boolean
  checkConfirmation: () => void
}

export const passwordReset = (passwordConfirmationError: string): AlpineComponent<PasswordResetComponent> => ({
  password: '',
  passwordConfirmation: '',

  init() {
    this.$watch('password', () => this.checkConfirmation())
    this.$watch('passwordConfirmation', () => this.checkConfirmation())
  },

  get passwordTooShort() {
    return this.password.length < 8
  },

  get infoColorClass() {
    if (this.password.length === 0) {
      return 'text-gray-500'
    } else if (this.passwordTooShort) {
      return 'text-red-600'
    } else {
      return 'text-green-600'
    }
  },

  get validConfirmation() {
    return !this.passwordConfirmation.length || this.password === this.passwordConfirmation
  },

  checkConfirmation() {
    const confirmationField = this.$refs.confirmationField as HTMLInputElement | undefined
    confirmationField?.setCustomValidity(this.validConfirmation ? '' : passwordConfirmationError)
  },
})
